import React from "react";
import styles from './SecondarySpan.module.css';

interface ISecondarySpan {
  isSecondary?: boolean
  children: React.ReactNode
}

const SecondarySpan: React.FC<ISecondarySpan> = ({ isSecondary = false, children }) => (
  <span className={isSecondary ? styles.secondarySpan : ''}>{children}</span>
);

export default SecondarySpan;